// 🪄 Klick-Handler für personalisierte Produkte (Trade-kompatibel)
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', async (e) => {
    const button = e.target.closest('.quick-btn-add-personalized');
    if (!button) return;
    e.preventDefault();
    e.stopPropagation();

    const variantId = button.dataset.variantId;
    const input = button.closest('.variant-item, .quick-order-extra, .variant-item__info')?.querySelector('input[name="properties[Wunschname]"]');

    const wunschname = input ? input.value.trim() : '';

    if (!wunschname) {
      alert('Bitte gib zuerst einen Wunschnamen ein.');
      return;
    }

    const formData = {
      id: variantId,
      quantity: 1,
      properties: { Wunschname: wunschname },
    };

    try {
      // Produkt hinzufügen
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) throw new Error('Fehler beim Hinzufügen');
      const data = await response.json();
      console.log('✅ Erfolgreich hinzugefügt:', data);

      if (input) {
        input.value = '';
      }

      // 🛒 Get updated cart data
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      // 🧮 Update cart bubble and total items
      updateCartBubble(cart);

      // 🛍 Drawer (Ajax-Warenkorb) neu laden und öffnen
      const cartDrawer = document.querySelector('cart-drawer, .cart-drawer');
      if (cartDrawer) {
        fetch('/?section_id=cart-drawer')
          .then((res) => res.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newDrawer = doc.querySelector('.drawer__inner');
            const currentDrawer = document.querySelector('.drawer__inner');
            if (newDrawer && currentDrawer) {
              currentDrawer.innerHTML = newDrawer.innerHTML;
              cartDrawer.classList.add('is-open');
            }
          })
          .catch((err) => console.error('Fehler beim Aktualisieren des Drawers:', err));
      }

      // 🔔 Trade-kompatible Events feuern
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));

      // 🔄 Trade-spezifische Aktualisierung
      if (window.Shopify && window.Shopify.theme && typeof window.Shopify.theme.cart === 'object') {
        try {
          window.Shopify.theme.cart.getCart().then((tradeCart) => {
            const bubble = document.querySelector('[data-cart-count]');
            if (bubble) bubble.textContent = tradeCart.item_count;
            document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: tradeCart }));
          });
        } catch (err) {
          console.warn('Trade-Warenkorb konnte nicht aktualisiert werden:', err);
        }
      }

      // 🧩 Optional: Publish-Event für Trade Theme
      try {
        if (typeof publish !== 'undefined') {
          publish(PUB_SUB_EVENTS?.cartUpdate || 'cartUpdate', {
            source: 'quick-order-list',
            cartData: cart,
          });
        }
      } catch (err) {
        console.warn('Publish Event fehlgeschlagen (nicht kritisch):', err);
      }

      alert(`„${data.product_title}" mit Wunschname „${wunschname}" wurde in den Warenkorb gelegt!`);
    } catch (err) {
      console.error('❌ Fehler beim Hinzufügen:', err);
      alert('Leider gab es ein Problem beim Hinzufügen zum Warenkorb.');
    }
  });
});

// === PLUS / MINUS Steuerung für normale (nicht personalisierte) Produkte ===
// document.addEventListener('click', async (event) => {
//   const button = event.target.closest('quick-order-list .quantity__button');
//   console.log('🔘 Klick auf Mengen-Button erkannt:', button);
//   if (!button) return;

//   const variantId = button.dataset.variantId;
//   const input = button.closest("quantity-input").querySelector(`.quantity__input[data-variant-id="${variantId}"]`);
//   if (!input) return;

//   let quantity = parseInt(input.value) || 0;
//   const action = button.getAttribute('name');
//   console.log(`⚙️ Aktuelle Menge für Variant ID ${variantId}:`, quantity, `| Aktion: ${action}`);

//   console.log(`🔄 Aktualisiere Menge für Variant ID ${variantId} auf ${quantity}`);
//   input.value = quantity;

//   try {
//     // 🛒 AJAX Update im Shopify Warenkorb
//     const response = await fetch('/cart/update.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ updates: { [variantId]: quantity } }),
//     });

//     const cart = await response.json();
//     console.log('🛍 Warenkorb aktualisiert:', cart);

//     // 🔔 Trade-kompatible Events triggern
//     document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
//     document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));

//     // 🧮 Update cart bubble and total items
//     updateCartBubble(cart);
//     updateTotalItems(cart);

//   } catch (error) {
//     console.error('❌ Fehler beim Warenkorb-Update:', error);
//   }
// });

// // 🔄 Function to update cart bubble with total item count
// function updateCartBubble(cart) {
//   const cartIcon = document.getElementById('cart-icon-bubble');

//   if (!cartIcon) {
//     console.warn('⚠️ Cart icon element not found');
//     return;
//   }

//   let bubble = cartIcon.querySelector('.cart-count-bubble');

//   // Create bubble if it doesn't exist
//   if (!bubble) {
//     bubble = document.createElement('div');
//     bubble.className = 'cart-count-bubble';
//     cartIcon.appendChild(bubble);
//     console.log('✨ Cart bubble created');
//   }

//   // Update the bubble text with item count
//   bubble.textContent = cart.item_count;

//   // Show/hide bubble based on count
//   if (cart.item_count > 0) {
//     bubble.classList.remove('cart-count-bubble--hidden');
//   } else {
//     bubble.classList.add('cart-count-bubble--hidden');
//   }

//   console.log('✅ Cart bubble updated:', cart.item_count);
// }

// // 📊 Function to update total items display (total quantity of current product's variants)
// function updateTotalItems(cart) {
//   const totalItemsElement = document.getElementById('quick-order-list__total-items');

//   if (totalItemsElement) {
//     // Get all variant IDs from the current product page
//     const quantityInputs = document.querySelectorAll('quick-order-list .quantity__input');
//     const currentProductVariantIds = new Set();

//     // Collect all variant IDs from the current product
//     quantityInputs.forEach(input => {
//       const variantId = input.dataset.variantId;
//       if (variantId) {
//         currentProductVariantIds.add(variantId);
//       }
//     });

//     // Sum up quantities of all variants from current product in the cart
//     let totalQuantity = 0;

//     cart.items.forEach(cartItem => {
//       const variantId = String(cartItem.variant_id);
//       // Only count quantity if this variant belongs to current product
//       if (currentProductVariantIds.has(variantId)) {
//         totalQuantity += cartItem.quantity;
//       }
//     });

//     totalItemsElement.textContent = totalQuantity;
//     console.log('✅ Current product total quantity in cart:', totalQuantity);
//   } else {
//     console.warn('⚠️ Total items element not found');
//   }
// }
 
document.addEventListener('click', async (event) => {
  const button = event.target.closest('quick-order-list .quantity__button');
  console.log('🔘 Klick auf Mengen-Button erkannt:', button);
  
  if (!button) return;
  
  const variantId = button.dataset.variantId;
  const input = button.closest("quantity-input").querySelector(`.quantity__input[data-variant-id="${variantId}"]`);
  
  if (!input) return;
  
  let quantity = parseInt(input.value) || 0;
  const action = button.getAttribute('name');
  
  console.log(`⚙️ Aktuelle Menge für Variant ID ${variantId}:`, quantity, `| Aktion: ${action}`);
  console.log(`🔄 Aktualisiere Menge für Variant ID ${variantId} auf ${quantity}`);
  
  input.value = quantity;
  
  try {
    // 🛒 AJAX Update im Shopify Warenkorb
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: { [variantId]: quantity }
      }),
    });
    
    const cart = await response.json();
    console.log('🛍 Warenkorb aktualisiert:', cart);
    
    // 🔔 Trade-kompatible Events triggern
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
    
    // 🧮 Update cart bubble, total items, and prices
    updateCartBubble(cart);
    updateTotalItems(cart);

    const variantRow = button.closest('tr');
    const variantTotalCell = variantRow?.querySelector('.variant_total');
    if (variantTotalCell) {
      const currentUrl = window.location.href;
      const tempDiv = document.createElement('div');
      const pageResponse = await fetch(currentUrl);
      tempDiv.innerHTML = await pageResponse.text();
      
      const newVariantRow = tempDiv.querySelector(`[data-variant-id="${variantId}"]`)?.closest('tr');
      const newVariantTotal = newVariantRow?.querySelector('.variant_total');
      
      if (newVariantTotal) {
        variantTotalCell.innerHTML = newVariantTotal.innerHTML;
      }
    }
    
    
  } catch (error) {
    console.error('❌ Fehler beim Warenkorb-Update:', error);
  }
});

// 🔄 Function to update cart bubble with total item count
function updateCartBubble(cart) {
  const cartIcon = document.getElementById('cart-icon-bubble');
  
  if (!cartIcon) {
    console.warn('⚠️ Cart icon element not found');
    return;
  }
  
  let bubble = cartIcon.querySelector('.cart-count-bubble');
  
  if (!bubble) {
    bubble = document.createElement('div');
    bubble.className = 'cart-count-bubble';
    cartIcon.appendChild(bubble);
    console.log('✨ Cart bubble created');
  }
  
  bubble.textContent = cart.item_count;
  
  if (cart.item_count > 0) {
    bubble.classList.remove('cart-count-bubble--hidden');
  } else {
    bubble.classList.add('cart-count-bubble--hidden');
  }
  
  console.log('✅ Cart bubble updated:', cart.item_count);
}

// 📊 Function to update total items display
function updateTotalItems(cart) {
  const totalItemsElement = document.getElementById('quick-order-list__total-items');
  
  if (totalItemsElement) {
    const quantityInputs = document.querySelectorAll('quick-order-list .quantity__input');
    const currentProductVariantIds = new Set();
    
    quantityInputs.forEach(input => {
      const variantId = input.dataset.variantId;
      if (variantId) {
        currentProductVariantIds.add(variantId);
      }
    });
    
    let totalQuantity = 0;
    cart.items.forEach(cartItem => {
      const variantId = String(cartItem.variant_id);
      if (currentProductVariantIds.has(variantId)) {
        totalQuantity += cartItem.quantity;
      }
    });
    
    totalItemsElement.textContent = totalQuantity;
    console.log('✅ Current product total quantity in cart:', totalQuantity);
  } else {
    console.warn('⚠️ Total items element not found');
  }
}


